import { THeroIcon } from '../types';

import { FadeIn } from './FadeIn';

/**
 * Data structure for a feature card.
 */
export interface IFeatureCard {
  /** The description of the feature card. */
  description: string;
  /** The icon to be displayed in the feature card. */
  icon: THeroIcon;
  /** The title of the feature card. */
  title: string;
}

/**
 * Configuration properties for the FeatureCard component.
 */
interface IFeatureCardProps {
  /** The feature card data to be rendered. */
  featureCard: IFeatureCard;
  /** The index of the card in a list, used for staggered animations. */
  index: number;
}

/**
 * A component that displays a feature with an icon, title, and description.
 */
export function FeatureCard({ featureCard, index }: IFeatureCardProps) {
  const { icon: Icon, title, description } = featureCard;

  return (
    <FadeIn
      className="
        max-lg:even:bordere-0 group flex w-full flex-col items-center gap-8 border-green-800/10
        px-14 even:border-x even:border-dashed
        last:max-lg:col-span-2 max-sm:col-span-2 max-sm:gap-6 max-sm:px-0
        max-sm:py-10 max-sm:first:pt-0 max-sm:last:pb-0 max-sm:even:border-x-0
        max-sm:even:border-y
      "
      delay={0.2 * index}
      initX={10}
    >
      <FadeIn className="w-18 h-18 rounded-full bg-green-600 p-3 p-4 shadow-xl group-hover:bg-green-500">
        <Icon
          className="
            mx-auto  h-10 w-10 self-center fill-transparent
            stroke-white stroke-1 group-hover:stroke-green-300
            group-focus:stroke-green-300
          "
        />
      </FadeIn>
      <div className="flex flex-col items-center gap-3 text-center">
        <div
          className="
            w-full text-2xl font-semibold text-gray-950 max-lg:text-xl
          "
        >
          {title}
        </div>
        <div className="max-w-80 text-lg text-gray-700 max-lg:text-base">
          {description}
        </div>
      </div>
    </FadeIn>
  );
}
